import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export class PortalHeaderDropdown extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  get currentHeading() {
    const { pathurl } = this.context.requestStore.requestLocation;
    if (pathurl.startsWith('/lehrer')) {
      return 'Lehrerbereich';
    }
    if (pathurl.startsWith('/eltern')) {
      return 'Elternbereich';
    }
    if (pathurl.startsWith('/statistik')) {
      return 'Statistikbereich';
    }
    if (pathurl.startsWith('/schueler') || pathurl.startsWith('/beitritt')) {
      return 'Schülerbereich';
    }
    if (pathurl.startsWith('/auth/recover')) {
      return 'Passwort vergessen';
    }
    if (pathurl.startsWith('/auth/link')) {
      return 'Weiterleitung';
    }
    if (pathurl.startsWith('/auth/transfer')) {
      return 'Account übertragen';
    }
    if (pathurl.startsWith('/admin')) {
      return 'Adminbereich';
    }
    if (pathurl.startsWith('/auth/signin')) {
      return 'Anmelden';
    }
    if (pathurl.startsWith('/auth/email')) {
      return 'Anmelden mit E-Mail';
    }
    if (pathurl.startsWith('/auth/passcode')) {
      return 'Anmelden mit Einmal-Passwort';
    }
    if (pathurl.startsWith('/auth/select')) {
      return 'Account auswählen';
    }
    if (pathurl.startsWith('/auth/signup')) {
      return 'Account erstellen';
    }
    if (pathurl.startsWith('/auth/manage')) {
      return 'Benutzer verwalten';
    }
    if (pathurl.startsWith('/auth/register')) {
      return 'Passwort erstellen';
    }
    if (pathurl.startsWith('/auth/login')) {
      return 'Schlaukopf Login';
    }
    if (pathurl.startsWith('/user/profile')) {
      return 'Account Einstellungen';
    }
    if (pathurl.startsWith('/auth/setpw')) {
      return 'Passwort setzen';
    }
    if (pathurl.startsWith('/auth/signout')) {
      return 'Logout';
    }
    if (pathurl.startsWith('/auth/code')) {
      return 'Login mit Anmelde-Code';
    }
    return 'Sonstiges';
  }

  render() {
    const { pathurl } = this.context.requestStore.requestLocation;

    return (
      <div className="header-switcher dropdown" style={{ marginLeft: 20 }}>
        <a
          href="#"
          className="btn btn-hover-primary font-weight-bold font-size-sm dropdown-toggle px-6 border-0"
          data-toggle="dropdown"
          data-offset="0px,1px"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {this.currentHeading}
        </a>
        <div className="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-left">
          {/*begin::Navigation*/}
          <ul className="navi navi-hover py-5">
            <li className="navi-item">
              <a href="/" className="navi-link">
                <span className="navi-icon">
                  <i className="flaticon2-rocket" />
                </span>
                <span className="navi-text">Schlaukopf Lernbereich</span>
              </a>
            </li>

          </ul>
          {/*end::Navigation*/}
        </div>
      </div>
    );
  }
}
